

// // subscriptionTypes
// export const MONTHLY = 0;
// export const QUARTERLY = 1;
// export const SEMI_ANNUALLY = 2;
// export const ANNUALLY = 3;




export const subscriptions = [
	{ 
		id: 1, 
		clubId: 3,
		exemptAdminPayment: false, 
		ExemptGroupLeadersPayment: false, 
		ExemptRelationsPayment: false, 
		OnlyRelationsPayment: false, 
		clubUserPaymentSubscriptionPlans: [
			{ 
				id: 1, 
				clubUserPaymentSubscriptionPlanstatus: 0, 
				assignedUserId: 10, 
				paymentPeriodStartDate: "2022-08-30 10:00", 
				paymentPeriodEndDate: null, 
				cubPaymentSubscriptionId: 1,  
				clubUserPaymentSubscriptionCharges: {
					"ClubUserPaymentSubscriptionCharge": {
						id: 1, 
						note: "", 
						internalNote: "", 
						amount: 100, 
						amountAfterTax: 60, 
						clubUserPaymentSubscriptionPlanId: 1, 
						assignedUserId: 10, 
						userPaymentStatus: 1, 
						statusLastUpdated: null, 
						deadline: "2022-09-30 10:00", 
						PaidDateTime: null, 
						paymentReceiptId: 76, 
						approved: null, 
						approvedById: null, 
						lockExpire:  null, 
						lockedById: null, 
						isLocked: false, 
						lastReminderSent: null, 
						hasSentScheduledNotification: null, 
						paymentMethodInfoId: null, 
						paidWith: "PaymentMethodInfo"
					},
					"ClubUserPaymentSubscriptionCharge": { 
						id: 2, 
						note: "", 
						internalNote: "", 
						amount: 100, 
						amountAfterTax: 60, 
						clubUserPaymentSubscriptionPlanId: 1, 
						assignedUserId: 10, 
						userPaymentStatus: 1, 
						statusLastUpdated: null, 
						deadline: "2022-09-30 10:00", 
						PaidDateTime: null, 
						paymentReceiptId: 76, 
						approved: null, 
						approvedById: null, 
						lockExpire:  null, 
						lockedById: null, 
						isLocked: false, 
						lastReminderSent: null, 
						hasSentScheduledNotification: null, 
						paymentMethodInfoId: null, 
						paidWith: "PaymentMethodInfo"
					},				
					"ClubUserPaymentSubscriptionCharge": { 
						id: 3, 
						note: "", 
						internalNote: "", 
						amount: 100, 
						amountAfterTax: 60, 
						clubUserPaymentSubscriptionPlanId: 1, 
						assignedUserId: 10, 
						userPaymentStatus: 1, 
						statusLastUpdated: null, 
						deadline: "2022-09-30 10:00", 
						PaidDateTime: null, 
						paymentReceiptId: 76, 
						approved: null, 
						approvedById: null, 
						lockExpire:  null, 
						lockedById: null, 
						isLocked: false, 
						lastReminderSent: null, 
						hasSentScheduledNotification: null, 
						paymentMethodInfoId: null, 
						paidWith: "PaymentMethodInfo"
					},
					"ClubUserPaymentSubscriptionCharge": { 
						id: 4, 
						note: "", 
						internalNote: "", 
						amount: 100, 
						amountAfterTax: 60, 
						clubUserPaymentSubscriptionPlanId: 1, 
						assignedUserId: 10, 
						userPaymentStatus: 1, 
						statusLastUpdated: null, 
						deadline: "2022-09-30 10:00", 
						PaidDateTime: null, 
						paymentReceiptId: 76, 
						approved: null, 
						approvedById: null, 
						lockExpire:  null, 
						lockedById: null, 
						isLocked: false, 
						lastReminderSent: null, 
						hasSentScheduledNotification: null, 
						paymentMethodInfoId: null, 
						paidWith: "PaymentMethodInfo"
					}				
				}
			},
			{ 
				id: 2, 
				clubUserPaymentSubscriptionPlanstatus: 0, 
				assignedUserId: 10, 
				paymentPeriodStartDate: "2022-08-30 10:00", 
				paymentPeriodEndDate: null, 
				cubPaymentSubscriptionId: 1,  
				clubUserPaymentSubscriptionCharges: {
					"ClubUserPaymentSubscriptionCharge": { 
						id: 1, 
						note: "", 
						internalNote: "", 
						amount: 100, 
						amountAfterTax: 60, 
						clubUserPaymentSubscriptionPlanId: 2, 
						assignedUserId: 10, 
						userPaymentStatus: 1, 
						statusLastUpdated: null, 
						deadline: "2022-09-30 10:00", 
						PaidDateTime: null, 
						paymentReceiptId: 76, 
						approved: null, 
						approvedById: null, 
						lockExpire:  null, 
						lockedById: null, 
						isLocked: false, 
						lastReminderSent: null, 
						hasSentScheduledNotification: null, 
						paymentMethodInfoId: null, 
						paidWith: "PaymentMethodInfo"
					},				
					"ClubUserPaymentSubscriptionCharge": { 
						id: 2, 
						note: "", 
						internalNote: "", 
						amount: 100, 
						amountAfterTax: 60, 
						clubUserPaymentSubscriptionPlanId: 2, 
						assignedUserId: 10, 
						userPaymentStatus: 1, 
						statusLastUpdated: null, 
						deadline: "2022-09-30 10:00", 
						PaidDateTime: null, 
						paymentReceiptId: 76, 
						approved: null, 
						approvedById: null, 
						lockExpire:  null, 
						lockedById: null, 
						isLocked: false, 
						lastReminderSent: null, 
						hasSentScheduledNotification: null, 
						paymentMethodInfoId: null, 
						paidWith: "PaymentMethodInfo"
					},				
					"ClubUserPaymentSubscriptionCharge": { 
						id: 3, 
						note: "", 
						internalNote: "", 
						amount: 100, 
						amountAfterTax: 60, 
						clubUserPaymentSubscriptionPlanId: 2, 
						assignedUserId: 10, 
						userPaymentStatus: 1, 
						statusLastUpdated: null, 
						deadline: "2022-09-30 10:00", 
						PaidDateTime: null, 
						paymentReceiptId: 76, 
						approved: null, 
						approvedById: null, 
						lockExpire:  null, 
						lockedById: null, 
						isLocked: false, 
						lastReminderSent: null, 
						hasSentScheduledNotification: null, 
						paymentMethodInfoId: null, 
						paidWith: "PaymentMethodInfo"
					},				
					"ClubUserPaymentSubscriptionCharge": { 
						id: 4, 
						note: "", 
						internalNote: "", 
						amount: 100, 
						amountAfterTax: 60, 
						clubUserPaymentSubscriptionPlanId: 2, 
						assignedUserId: 10, 
						userPaymentStatus: 1, 
						statusLastUpdated: null, 
						deadline: "2022-09-30 10:00", 
						PaidDateTime: null, 
						paymentReceiptId: 76, 
						approved: null, 
						approvedById: null, 
						lockExpire:  null, 
						lockedById: null, 
						isLocked: false, 
						lastReminderSent: null, 
						hasSentScheduledNotification: null, 
						paymentMethodInfoId: null, 
						paidWith: "PaymentMethodInfo"
					}
				}
			},
			{ 
				id: 3, 
				clubUserPaymentSubscriptionPlanstatus: 0, 
				assignedUserId: 10, 
				paymentPeriodStartDate: "2022-08-30 10:00", 
				paymentPeriodEndDate: null, 
				cubPaymentSubscriptionId: 1,  
				clubUserPaymentSubscriptionCharges: {
					"ClubUserPaymentSubscriptionCharge": { 
						id: 1, 
						note: "", 
						internalNote: "", 
						amount: 100, 
						amountAfterTax: 60, 
						clubUserPaymentSubscriptionPlanId: 3, 
						assignedUserId: 10, 
						userPaymentStatus: 1, 
						statusLastUpdated: null, 
						deadline: "2022-09-30 10:00", 
						PaidDateTime: null, 
						paymentReceiptId: 76, 
						approved: null, 
						approvedById: null, 
						lockExpire:  null, 
						lockedById: null, 
						isLocked: false, 
						lastReminderSent: null, 
						hasSentScheduledNotification: null, 
						paymentMethodInfoId: null, 
						paidWith: "PaymentMethodInfo"
					},				
					"ClubUserPaymentSubscriptionCharge": { 
						id: 2, 
						note: "", 
						internalNote: "", 
						amount: 100, 
						amountAfterTax: 60, 
						clubUserPaymentSubscriptionPlanId: 3, 
						assignedUserId: 10, 
						userPaymentStatus: 1, 
						statusLastUpdated: null, 
						deadline: "2022-09-30 10:00", 
						PaidDateTime: null, 
						paymentReceiptId: 76, 
						approved: null, 
						approvedById: null, 
						lockExpire:  null, 
						lockedById: null, 
						isLocked: false, 
						lastReminderSent: null, 
						hasSentScheduledNotification: null, 
						paymentMethodInfoId: null, 
						paidWith: "PaymentMethodInfo"
					},				
					"ClubUserPaymentSubscriptionCharge": { 
						id: 3, 
						note: "", 
						internalNote: "", 
						amount: 100, 
						amountAfterTax: 60, 
						clubUserPaymentSubscriptionPlanId: 3, 
						assignedUserId: 10, 
						userPaymentStatus: 1, 
						statusLastUpdated: null, 
						deadline: "2022-09-30 10:00", 
						PaidDateTime: null, 
						paymentReceiptId: 76, 
						approved: null, 
						approvedById: null, 
						lockExpire:  null, 
						lockedById: null, 
						isLocked: false, 
						lastReminderSent: null, 
						hasSentScheduledNotification: null, 
						paymentMethodInfoId: null, 
						paidWith: "PaymentMethodInfo"
					},			
					"ClubUserPaymentSubscriptionCharge": { 
						id: 4, 
						note: "", 
						internalNote: "", 
						amount: 100, 
						amountAfterTax: 60, 
						clubUserPaymentSubscriptionPlanId: 3, 
						assignedUserId: 10, 
						userPaymentStatus: 1, 
						statusLastUpdated: null, 
						deadline: "2022-09-30 10:00", 
						PaidDateTime: null, 
						paymentReceiptId: 76, 
						approved: null, 
						approvedById: null, 
						lockExpire:  null, 
						lockedById: null, 
						isLocked: false, 
						lastReminderSent: null, 
						hasSentScheduledNotification: null, 
						paymentMethodInfoId: null, 
						paidWith: "PaymentMethodInfo"
					}
				}
			},	
			{ 	
				id: 4, 
				clubUserPaymentSubscriptionPlanstatus: 0, 
				assignedUserId: 10, 
				paymentPeriodStartDate: "2022-08-30 10:00", 
				paymentPeriodEndDate: null, 
				cubPaymentSubscriptionId: 1,  
				clubUserPaymentSubscriptionCharges: {
					"ClubUserPaymentSubscriptionCharge": { 
						id: 1, 
						note: "", 
						internalNote: "", 
						amount: 100, 
						amountAfterTax: 60, 
						clubUserPaymentSubscriptionPlanId: 4, 
						assignedUserId: 10, 
						userPaymentStatus: 1, 
						statusLastUpdated: null, 
						deadline: "2022-09-30 10:00", 
						PaidDateTime: null, 
						paymentReceiptId: 76, 
						approved: null, 
						approvedById: null, 
						lockExpire:  null, 
						lockedById: null, 
						isLocked: false, 
						lastReminderSent: null, 
						hasSentScheduledNotification: null, 
						paymentMethodInfoId: null, 
						paidWith: "PaymentMethodInfo"
					},				
					"ClubUserPaymentSubscriptionCharge": { 
						id: 2, 
						note: "", 
						internalNote: "", 
						amount: 100, 
						amountAfterTax: 60, 
						clubUserPaymentSubscriptionPlanId: 4, 
						assignedUserId: 10, 
						userPaymentStatus: 1, 
						statusLastUpdated: null, 
						deadline: "2022-09-30 10:00", 
						PaidDateTime: null, 
						paymentReceiptId: 76, 
						approved: null, 
						approvedById: null, 
						lockExpire:  null, 
						lockedById: null, 
						isLocked: false, 
						lastReminderSent: null, 
						hasSentScheduledNotification: null, 
						paymentMethodInfoId: null, 
						paidWith: "PaymentMethodInfo"
					},				
					"ClubUserPaymentSubscriptionCharge": { 
						id: 3, 
						note: "", 
						internalNote: "", 
						amount: 100, 
						amountAfterTax: 60, 
						clubUserPaymentSubscriptionPlanId: 4, 
						assignedUserId: 10, 
						userPaymentStatus: 1, 
						statusLastUpdated: null, 
						deadline: "2022-09-30 10:00", 
						PaidDateTime: null, 
						paymentReceiptId: 76, 
						approved: null, 
						approvedById: null, 
						lockExpire:  null, 
						lockedById: null, 
						isLocked: false, 
						lastReminderSent: null, 
						hasSentScheduledNotification: null, 
						paymentMethodInfoId: null, 
						paidWith: "PaymentMethodInfo"
					},				
					"ClubUserPaymentSubscriptionCharge": { 
						id: 4, 
						note: "", 
						internalNote: "", 
						amount: 100, 
						amountAfterTax: 60, 
						clubUserPaymentSubscriptionPlanId: 4, 
						assignedUserId: 10, 
						userPaymentStatus: 1, 
						statusLastUpdated: null, 
						deadline: "2022-09-30 10:00", 
						PaidDateTime: null, 
						paymentReceiptId: 76, 
						approved: null, 
						approvedById: null, 
						lockExpire:  null, 
						lockedById: null, 
						isLocked: false, 
						lastReminderSent: null, 
						hasSentScheduledNotification: null, 
						paymentMethodInfoId: null, 
						paidWith: "PaymentMethodInfo"
					}
				}
			},	
		],
		durationInterval: "12",
		title:"First Club Subscription", 
		amount: 100, 
		CreatedByUserId: 10, 
		paymentPeriodStartDate: "2022-08-30 10:00" , 
		paymentPeriodEndDate: null
	},
	{ 
		id: 2, 
		clubId: 3, 		  
		exemptAdminPayment: false, 
		ExemptGroupLeadersPayment: false, 
		ExemptRelationsPayment: false, 
		OnlyRelationsPayment: false, 
		clubUserPaymentSubscriptionPlans: [
			{ 
				id: 1, 
				clubUserPaymentSubscriptionPlanstatus: 0, 
				assignedUserId: 10, 
				paymentPeriodStartDate: "2022-08-30", 
				paymentPeriodEndDate: null, 
				cubPaymentSubscriptionId: 2,  
				clubUserPaymentSubscriptionCharges: {
					"ClubUserPaymentSubscriptionCharge": {
						id: 1, 
						note: "", 
						internalNote: "", 
						amount: 100, 
						amountAfterTax: 60, 
						clubUserPaymentSubscriptionPlanId: 1, 
						assignedUserId: 10, 
						userPaymentStatus: 1, 
						statusLastUpdated: null, 
						deadline: "2022-09-30 10:00", 
						PaidDateTime: null, 
						paymentReceiptId: 76, 
						approved: null, 
						approvedById: null, 
						lockExpire:  null, 
						lockedById: null, 
						isLocked: false, 
						lastReminderSent: null, 
						hasSentScheduledNotification: null, 
						paymentMethodInfoId: null, 
						paidWith: "PaymentMethodInfo"
					},
					"ClubUserPaymentSubscriptionCharge": { 
						id: 2, 
						note: "", 
						internalNote: "", 
						amount: 100, 
						amountAfterTax: 60, 
						clubUserPaymentSubscriptionPlanId: 1, 
						assignedUserId: 10, 
						userPaymentStatus: 1, 
						statusLastUpdated: null, 
						deadline: "2022-09-30 10:00", 
						PaidDateTime: null, 
						paymentReceiptId: 76, 
						approved: null, 
						approvedById: null, 
						lockExpire:  null, 
						lockedById: null, 
						isLocked: false, 
						lastReminderSent: null, 
						hasSentScheduledNotification: null, 
						paymentMethodInfoId: null, 
						paidWith: "PaymentMethodInfo"
					},				
					"ClubUserPaymentSubscriptionCharge": { 
						id: 3, 
						note: "", 
						internalNote: "", 
						amount: 100, 
						amountAfterTax: 60, 
						clubUserPaymentSubscriptionPlanId: 1, 
						assignedUserId: 10, 
						userPaymentStatus: 1, 
						statusLastUpdated: null, 
						deadline: "2022-09-30 10:00", 
						PaidDateTime: null, 
						paymentReceiptId: 76, 
						approved: null, 
						approvedById: null, 
						lockExpire:  null, 
						lockedById: null, 
						isLocked: false, 
						lastReminderSent: null, 
						hasSentScheduledNotification: null, 
						paymentMethodInfoId: null, 
						paidWith: "PaymentMethodInfo"
					},
					"ClubUserPaymentSubscriptionCharge": { 
						id: 4, 
						note: "", 
						internalNote: "", 
						amount: 100, 
						amountAfterTax: 60, 
						clubUserPaymentSubscriptionPlanId: 1, 
						assignedUserId: 10, 
						userPaymentStatus: 1, 
						statusLastUpdated: null, 
						deadline: "2022-09-30 10:00", 
						PaidDateTime: null, 
						paymentReceiptId: 76, 
						approved: null, 
						approvedById: null, 
						lockExpire:  null, 
						lockedById: null, 
						isLocked: false, 
						lastReminderSent: null, 
						hasSentScheduledNotification: null, 
						paymentMethodInfoId: null, 
						paidWith: "PaymentMethodInfo"
					}				
				}
			},
			{ 
				id: 2, 
				clubUserPaymentSubscriptionPlanstatus: 0, 
				assignedUserId: 10, 
				paymentPeriodStartDate: "2022-08-30", 
				paymentPeriodEndDate: null, 
				cubPaymentSubscriptionId: 2,  
				clubUserPaymentSubscriptionCharges: {
					"ClubUserPaymentSubscriptionCharge": { 
						id: 1, 
						note: "", 
						internalNote: "", 
						amount: 100, 
						amountAfterTax: 60, 
						clubUserPaymentSubscriptionPlanId: 2, 
						assignedUserId: 10, 
						userPaymentStatus: 1, 
						statusLastUpdated: null, 
						deadline: "2022-09-30 10:00", 
						PaidDateTime: null, 
						paymentReceiptId: 76, 
						approved: null, 
						approvedById: null, 
						lockExpire:  null, 
						lockedById: null, 
						isLocked: false, 
						lastReminderSent: null, 
						hasSentScheduledNotification: null, 
						paymentMethodInfoId: null, 
						paidWith: "PaymentMethodInfo"
					},				
					"ClubUserPaymentSubscriptionCharge": { 
						id: 2, 
						note: "", 
						internalNote: "", 
						amount: 100, 
						amountAfterTax: 60, 
						clubUserPaymentSubscriptionPlanId: 2, 
						assignedUserId: 10, 
						userPaymentStatus: 1, 
						statusLastUpdated: null, 
						deadline: "2022-09-30 10:00", 
						PaidDateTime: null, 
						paymentReceiptId: 76, 
						approved: null, 
						approvedById: null, 
						lockExpire:  null, 
						lockedById: null, 
						isLocked: false, 
						lastReminderSent: null, 
						hasSentScheduledNotification: null, 
						paymentMethodInfoId: null, 
						paidWith: "PaymentMethodInfo"
					},				
					"ClubUserPaymentSubscriptionCharge": { 
						id: 3, 
						note: "", 
						internalNote: "", 
						amount: 100, 
						amountAfterTax: 60, 
						clubUserPaymentSubscriptionPlanId: 2, 
						assignedUserId: 10, 
						userPaymentStatus: 1, 
						statusLastUpdated: null, 
						deadline: "2022-09-30 10:00", 
						PaidDateTime: null, 
						paymentReceiptId: 76, 
						approved: null, 
						approvedById: null, 
						lockExpire:  null, 
						lockedById: null, 
						isLocked: false, 
						lastReminderSent: null, 
						hasSentScheduledNotification: null, 
						paymentMethodInfoId: null, 
						paidWith: "PaymentMethodInfo"
					},				
					"ClubUserPaymentSubscriptionCharge": { 
						id: 4, 
						note: "", 
						internalNote: "", 
						amount: 100, 
						amountAfterTax: 60, 
						clubUserPaymentSubscriptionPlanId: 2, 
						assignedUserId: 10, 
						userPaymentStatus: 1, 
						statusLastUpdated: null, 
						deadline: "2022-09-30 10:00", 
						PaidDateTime: null, 
						paymentReceiptId: 76, 
						approved: null, 
						approvedById: null, 
						lockExpire:  null, 
						lockedById: null, 
						isLocked: false, 
						lastReminderSent: null, 
						hasSentScheduledNotification: null, 
						paymentMethodInfoId: null, 
						paidWith: "PaymentMethodInfo"
					}
				}
			},
			{ 
				id: 3, 
				clubUserPaymentSubscriptionPlanstatus: 0, 
				assignedUserId: 10, 
				paymentPeriodStartDate: "2022-08-30", 
				paymentPeriodEndDate: null, 
				cubPaymentSubscriptionId: 2,  
				clubUserPaymentSubscriptionCharges: {
					"ClubUserPaymentSubscriptionCharge": { 
						id: 1, 
						note: "", 
						internalNote: "", 
						amount: 100, 
						amountAfterTax: 60, 
						clubUserPaymentSubscriptionPlanId: 3, 
						assignedUserId: 10, 
						userPaymentStatus: 1, 
						statusLastUpdated: null, 
						deadline: "2022-09-30 10:00", 
						PaidDateTime: null, 
						paymentReceiptId: 76, 
						approved: null, 
						approvedById: null, 
						lockExpire:  null, 
						lockedById: null, 
						isLocked: false, 
						lastReminderSent: null, 
						hasSentScheduledNotification: null, 
						paymentMethodInfoId: null, 
						paidWith: "PaymentMethodInfo"
					},				
					"ClubUserPaymentSubscriptionCharge": { 
						id: 2, 
						note: "", 
						internalNote: "", 
						amount: 100, 
						amountAfterTax: 60, 
						clubUserPaymentSubscriptionPlanId: 3, 
						assignedUserId: 10, 
						userPaymentStatus: 1, 
						statusLastUpdated: null, 
						deadline: "2022-09-30 10:00", 
						PaidDateTime: null, 
						paymentReceiptId: 76, 
						approved: null, 
						approvedById: null, 
						lockExpire:  null, 
						lockedById: null, 
						isLocked: false, 
						lastReminderSent: null, 
						hasSentScheduledNotification: null, 
						paymentMethodInfoId: null, 
						paidWith: "PaymentMethodInfo"
					},				
					"ClubUserPaymentSubscriptionCharge": { 
						id: 3, 
						note: "", 
						internalNote: "", 
						amount: 100, 
						amountAfterTax: 60, 
						clubUserPaymentSubscriptionPlanId: 3, 
						assignedUserId: 10, 
						userPaymentStatus: 1, 
						statusLastUpdated: null, 
						deadline: "2022-09-30 10:00", 
						PaidDateTime: null, 
						paymentReceiptId: 76, 
						approved: null, 
						approvedById: null, 
						lockExpire:  null, 
						lockedById: null, 
						isLocked: false, 
						lastReminderSent: null, 
						hasSentScheduledNotification: null, 
						paymentMethodInfoId: null, 
						paidWith: "PaymentMethodInfo"
					},			
					"ClubUserPaymentSubscriptionCharge": { 
						id: 4, 
						note: "", 
						internalNote: "", 
						amount: 100, 
						amountAfterTax: 60, 
						clubUserPaymentSubscriptionPlanId: 3, 
						assignedUserId: 10, 
						userPaymentStatus: 1, 
						statusLastUpdated: null, 
						deadline: "2022-09-30 10:00", 
						PaidDateTime: null, 
						paymentReceiptId: 76, 
						approved: null, 
						approvedById: null, 
						lockExpire:  null, 
						lockedById: null, 
						isLocked: false, 
						lastReminderSent: null, 
						hasSentScheduledNotification: null, 
						paymentMethodInfoId: null, 
						paidWith: "PaymentMethodInfo"
					}
				}
			},	
			{ 	
				id: 4, 
				clubUserPaymentSubscriptionPlanstatus: 0, 
				assignedUserId: 10, 
				paymentPeriodStartDate: "2022-08-30", 
				paymentPeriodEndDate: null, 
				cubPaymentSubscriptionId: 2,  
				clubUserPaymentSubscriptionCharges: {
					"ClubUserPaymentSubscriptionCharge": { 
						id: 1, 
						note: "", 
						internalNote: "", 
						amount: 100, 
						amountAfterTax: 60, 
						clubUserPaymentSubscriptionPlanId: 4, 
						assignedUserId: 10, 
						userPaymentStatus: 1, 
						statusLastUpdated: null, 
						deadline: "2022-09-30 10:00", 
						PaidDateTime: null, 
						paymentReceiptId: 76, 
						approved: null, 
						approvedById: null, 
						lockExpire:  null, 
						lockedById: null, 
						isLocked: false, 
						lastReminderSent: null, 
						hasSentScheduledNotification: null, 
						paymentMethodInfoId: null, 
						paidWith: "PaymentMethodInfo"
					},				
					"ClubUserPaymentSubscriptionCharge": { 
						id: 2, 
						note: "", 
						internalNote: "", 
						amount: 100, 
						amountAfterTax: 60, 
						clubUserPaymentSubscriptionPlanId: 4, 
						assignedUserId: 10, 
						userPaymentStatus: 1, 
						statusLastUpdated: null, 
						deadline: "2022-09-30 10:00", 
						PaidDateTime: null, 
						paymentReceiptId: 76, 
						approved: null, 
						approvedById: null, 
						lockExpire:  null, 
						lockedById: null, 
						isLocked: false, 
						lastReminderSent: null, 
						hasSentScheduledNotification: null, 
						paymentMethodInfoId: null, 
						paidWith: "PaymentMethodInfo"
					},				
					"ClubUserPaymentSubscriptionCharge": { 
						id: 3, 
						note: "", 
						internalNote: "", 
						amount: 100, 
						amountAfterTax: 60, 
						clubUserPaymentSubscriptionPlanId: 4, 
						assignedUserId: 10, 
						userPaymentStatus: 1, 
						statusLastUpdated: null, 
						deadline: "2022-09-30 10:00", 
						PaidDateTime: null, 
						paymentReceiptId: 76, 
						approved: null, 
						approvedById: null, 
						lockExpire:  null, 
						lockedById: null, 
						isLocked: false, 
						lastReminderSent: null, 
						hasSentScheduledNotification: null, 
						paymentMethodInfoId: null, 
						paidWith: "PaymentMethodInfo"
					},				
					"ClubUserPaymentSubscriptionCharge": { 
						id: 4, 
						note: "", 
						internalNote: "", 
						amount: 100, 
						amountAfterTax: 60, 
						clubUserPaymentSubscriptionPlanId: 4, 
						assignedUserId: 10, 
						userPaymentStatus: 1, 
						statusLastUpdated: null, 
						deadline: "2022-09-30 10:00", 
						PaidDateTime: null, 
						paymentReceiptId: 76, 
						approved: null, 
						approvedById: null, 
						lockExpire:  null, 
						lockedById: null, 
						isLocked: false, 
						lastReminderSent: null, 
						hasSentScheduledNotification: null, 
						paymentMethodInfoId: null, 
						paidWith: "PaymentMethodInfo"
					}
				}
			},	
		],
		durationInterval: "23",
		title:"Second Club Subscription", 
		amount: 100, 
		CreatedByUserId: 10, 
		paymentPeriodStartDate: "2022-08-30 10:00", 
		paymentPeriodEndDate: null
	},
]

export const subscriptionPlans = [
	{ 
		id: 1, 
		clubUserPaymentSubscriptionPlanstatus: 0, 
		assignedUserId: 10, 
		amount: 100,
		paymentPeriodStartDate: "2022-08-30", 
		paymentPeriodEndDate: null, 
		cubPaymentSubscriptionId: 1,  
		clubUserPaymentSubscriptionCharges: [
			{
				id: 1, 
				note: "", 
				internalNote: "", 
				amount: 100, 
				amountAfterTax: 60, 
				clubUserPaymentSubscriptionPlanId: 1, 
				assignedUserId: 10, 
				userPaymentStatus: 1, 
				statusLastUpdated: null, 
				deadline: "2022-09-30 10:00", 
				PaidDateTime: null, 
				paymentReceiptId: 76, 
				approved: null, 
				approvedById: null, 
				lockExpire:  null, 
				lockedById: null, 
				isLocked: false, 
				lastReminderSent: null, 
				hasSentScheduledNotification: null, 
				paymentMethodInfoId: null, 
				paidWith: "PaymentMethodInfo"
			},
			{ 
				id: 2, 
				note: "", 
				internalNote: "", 
				amount: 100, 
				amountAfterTax: 60, 
				clubUserPaymentSubscriptionPlanId: 1, 
				assignedUserId: 10, 
				userPaymentStatus: 1, 
				statusLastUpdated: null, 
				deadline: "2022-09-30 10:00", 
				PaidDateTime: null, 
				paymentReceiptId: 76, 
				approved: null, 
				approvedById: null, 
				lockExpire:  null, 
				lockedById: null, 
				isLocked: false, 
				lastReminderSent: null, 
				hasSentScheduledNotification: null, 
				paymentMethodInfoId: null, 
				paidWith: "PaymentMethodInfo"
			},				
			{ 
				id: 3, 
				note: "", 
				internalNote: "", 
				amount: 100, 
				amountAfterTax: 60, 
				clubUserPaymentSubscriptionPlanId: 1, 
				assignedUserId: 10, 
				userPaymentStatus: 1, 
				statusLastUpdated: null, 
				deadline: "2022-09-30 10:00", 
				PaidDateTime: null, 
				paymentReceiptId: 76, 
				approved: null, 
				approvedById: null, 
				lockExpire:  null, 
				lockedById: null, 
				isLocked: false, 
				lastReminderSent: null, 
				hasSentScheduledNotification: null, 
				paymentMethodInfoId: null, 
				paidWith: "PaymentMethodInfo"
			},
			{ 
				id: 4, 
				note: "", 
				internalNote: "", 
				amount: 100, 
				amountAfterTax: 60, 
				clubUserPaymentSubscriptionPlanId: 1, 
				assignedUserId: 10, 
				userPaymentStatus: 1, 
				statusLastUpdated: null, 
				deadline: "2022-09-30 10:00", 
				PaidDateTime: null, 
				paymentReceiptId: 76, 
				approved: null, 
				approvedById: null, 
				lockExpire:  null, 
				lockedById: null, 
				isLocked: false, 
				lastReminderSent: null, 
				hasSentScheduledNotification: null, 
				paymentMethodInfoId: null, 
				paidWith: "PaymentMethodInfo"
			}						
		],
		durationInterval: "12",
	},
	{ 
		id: 2, 
		clubUserPaymentSubscriptionPlanstatus: 0, 
		assignedUserId: 10, 
		amount: 100,
		paymentPeriodStartDate: "2022-08-30", 
		paymentPeriodEndDate: null, 
		cubPaymentSubscriptionId: 1,  
		clubUserPaymentSubscriptionCharges: [
			{ 
				id: 1, 
				note: "", 
				internalNote: "", 
				amount: 100, 
				amountAfterTax: 60, 
				clubUserPaymentSubscriptionPlanId: 2, 
				assignedUserId: 10, 
				userPaymentStatus: 1, 
				statusLastUpdated: null, 
				deadline: "2022-09-30 10:00", 
				PaidDateTime: null, 
				paymentReceiptId: 76, 
				approved: null, 
				approvedById: null, 
				lockExpire:  null, 
				lockedById: null, 
				isLocked: false, 
				lastReminderSent: null, 
				hasSentScheduledNotification: null, 
				paymentMethodInfoId: null, 
				paidWith: "PaymentMethodInfo"
			},
			{ 
				id: 2, 
				note: "", 
				internalNote: "", 
				amount: 100, 
				amountAfterTax: 60, 
				clubUserPaymentSubscriptionPlanId: 2, 
				assignedUserId: 10, 
				userPaymentStatus: 1, 
				statusLastUpdated: null, 
				deadline: "2022-09-30 10:00", 
				PaidDateTime: null, 
				paymentReceiptId: 76, 
				approved: null, 
				approvedById: null, 
				lockExpire:  null, 
				lockedById: null, 
				isLocked: false, 
				lastReminderSent: null, 
				hasSentScheduledNotification: null, 
				paymentMethodInfoId: null, 
				paidWith: "PaymentMethodInfo"
			},
			{ 
				id: 3, 
				note: "", 
				internalNote: "", 
				amount: 100, 
				amountAfterTax: 60, 
				clubUserPaymentSubscriptionPlanId: 2, 
				assignedUserId: 10, 
				userPaymentStatus: 1, 
				statusLastUpdated: null, 
				deadline: "2022-09-30 10:00", 
				PaidDateTime: null, 
				paymentReceiptId: 76, 
				approved: null, 
				approvedById: null, 
				lockExpire:  null, 
				lockedById: null, 
				isLocked: false, 
				lastReminderSent: null, 
				hasSentScheduledNotification: null, 
				paymentMethodInfoId: null, 
				paidWith: "PaymentMethodInfo"
			},
			{ 
				id: 4, 
				note: "", 
				internalNote: "", 
				amount: 100, 
				amountAfterTax: 60, 
				clubUserPaymentSubscriptionPlanId: 2, 
				assignedUserId: 10, 
				userPaymentStatus: 1, 
				statusLastUpdated: null, 
				deadline: "2022-09-30 10:00", 
				PaidDateTime: null, 
				paymentReceiptId: 76, 
				approved: null, 
				approvedById: null, 
				lockExpire:  null, 
				lockedById: null, 
				isLocked: false, 
				lastReminderSent: null, 
				hasSentScheduledNotification: null, 
				paymentMethodInfoId: null, 
				paidWith: "PaymentMethodInfo"
			}
		],
		durationInterval: "12",
	},
	{ 
		id: 3, 
		clubUserPaymentSubscriptionPlanstatus: 0, 
		assignedUserId: 10,
		amount: 100,
		paymentPeriodStartDate: "2022-08-30", 
		paymentPeriodEndDate: null, 
		cubPaymentSubscriptionId: 1,  
		clubUserPaymentSubscriptionCharges: [
			{ 
				id: 1, 
				note: "", 
				internalNote: "", 
				amount: 100, 
				amountAfterTax: 60, 
				clubUserPaymentSubscriptionPlanId: 3, 
				assignedUserId: 10, 
				userPaymentStatus: 1, 
				statusLastUpdated: null, 
				deadline: "2022-09-30 10:00", 
				PaidDateTime: null, 
				paymentReceiptId: 76, 
				approved: null, 
				approvedById: null, 
				lockExpire:  null, 
				lockedById: null, 
				isLocked: false, 
				lastReminderSent: null, 
				hasSentScheduledNotification: null, 
				paymentMethodInfoId: null, 
				paidWith: "PaymentMethodInfo"
			},
			{ 
				id: 2, 
				note: "", 
				internalNote: "", 
				amount: 100, 
				amountAfterTax: 60, 
				clubUserPaymentSubscriptionPlanId: 3, 
				assignedUserId: 10, 
				userPaymentStatus: 1, 
				statusLastUpdated: null, 
				deadline: "2022-09-30 10:00", 
				PaidDateTime: null, 
				paymentReceiptId: 76, 
				approved: null, 
				approvedById: null, 
				lockExpire:  null, 
				lockedById: null, 
				isLocked: false, 
				lastReminderSent: null, 
				hasSentScheduledNotification: null, 
				paymentMethodInfoId: null, 
				paidWith: "PaymentMethodInfo"
			},
			{ 
				id: 3, 
				note: "", 
				internalNote: "", 
				amount: 100, 
				amountAfterTax: 60, 
				clubUserPaymentSubscriptionPlanId: 3, 
				assignedUserId: 10, 
				userPaymentStatus: 1, 
				statusLastUpdated: null, 
				deadline: "2022-09-30 10:00", 
				PaidDateTime: null, 
				paymentReceiptId: 76, 
				approved: null, 
				approvedById: null, 
				lockExpire:  null, 
				lockedById: null, 
				isLocked: false, 
				lastReminderSent: null, 
				hasSentScheduledNotification: null, 
				paymentMethodInfoId: null, 
				paidWith: "PaymentMethodInfo"
			},
			{ 
				id: 4, 
				note: "", 
				internalNote: "", 
				amount: 100, 
				amountAfterTax: 60, 
				clubUserPaymentSubscriptionPlanId: 3, 
				assignedUserId: 10, 
				userPaymentStatus: 1, 
				statusLastUpdated: null, 
				deadline: "2022-09-30 10:00", 
				PaidDateTime: null, 
				paymentReceiptId: 76, 
				approved: null, 
				approvedById: null, 
				lockExpire:  null, 
				lockedById: null, 
				isLocked: false, 
				lastReminderSent: null, 
				hasSentScheduledNotification: null, 
				paymentMethodInfoId: null, 
				paidWith: "PaymentMethodInfo"
			}
		],
		durationInterval: "12",
	},
	{ 	
		id: 4, 
		clubUserPaymentSubscriptionPlanstatus: 0, 
		assignedUserId: 10,
		amount: 100,
		paymentPeriodStartDate: "2022-08-30", 
		paymentPeriodEndDate: null, 
		cubPaymentSubscriptionId: 1,  
		clubUserPaymentSubscriptionCharges: [
			{ 
				id: 1, 
				note: "", 
				internalNote: "", 
				amount: 100, 
				amountAfterTax: 60, 
				clubUserPaymentSubscriptionPlanId: 4, 
				assignedUserId: 10, 
				userPaymentStatus: 1, 
				statusLastUpdated: null, 
				deadline: "2022-09-30 10:00", 
				PaidDateTime: null, 
				paymentReceiptId: 76, 
				approved: null, 
				approvedById: null, 
				lockExpire:  null, 
				lockedById: null, 
				isLocked: false, 
				lastReminderSent: null, 
				hasSentScheduledNotification: null, 
				paymentMethodInfoId: null, 
				paidWith: "PaymentMethodInfo"
			},			
			{ 
				id: 2, 
				note: "", 
				internalNote: "", 
				amount: 100, 
				amountAfterTax: 60, 
				clubUserPaymentSubscriptionPlanId: 4, 
				assignedUserId: 10, 
				userPaymentStatus: 1, 
				statusLastUpdated: null, 
				deadline: "2022-09-30 10:00", 
				PaidDateTime: null, 
				paymentReceiptId: 76, 
				approved: null, 
				approvedById: null, 
				lockExpire:  null, 
				lockedById: null, 
				isLocked: false, 
				lastReminderSent: null, 
				hasSentScheduledNotification: null, 
				paymentMethodInfoId: null, 
				paidWith: "PaymentMethodInfo"
			},				
			{ 
				id: 3, 
				note: "", 
				internalNote: "", 
				amount: 100, 
				amountAfterTax: 60, 
				clubUserPaymentSubscriptionPlanId: 4, 
				assignedUserId: 10, 
				userPaymentStatus: 1, 
				statusLastUpdated: null, 
				deadline: "2022-09-30 10:00", 
				PaidDateTime: null, 
				paymentReceiptId: 76, 
				approved: null, 
				approvedById: null, 
				lockExpire:  null, 
				lockedById: null, 
				isLocked: false, 
				lastReminderSent: null, 
				hasSentScheduledNotification: null, 
				paymentMethodInfoId: null, 
				paidWith: "PaymentMethodInfo"
			},			
			{ 
				id: 4, 
				note: "", 
				internalNote: "", 
				amount: 100, 
				amountAfterTax: 60, 
				clubUserPaymentSubscriptionPlanId: 4, 
				assignedUserId: 10, 
				userPaymentStatus: 1, 
				statusLastUpdated: null, 
				deadline: "2022-09-30 10:00", 
				PaidDateTime: null, 
				paymentReceiptId: 76, 
				approved: null, 
				approvedById: null, 
				lockExpire:  null, 
				lockedById: null, 
				isLocked: false, 
				lastReminderSent: null, 
				hasSentScheduledNotification: null, 
				paymentMethodInfoId: null, 
				paidWith: "PaymentMethodInfo"
			}
		],
		durationInterval: "12",
	},
	{ 
		id: 1, 
		clubUserPaymentSubscriptionPlanstatus: 0, 
		assignedUserId: 10,
		amount: 100,
		paymentPeriodStartDate: "2022-08-30", 
		paymentPeriodEndDate: null, 
		cubPaymentSubscriptionId: 2,  
		clubUserPaymentSubscriptionCharges: [
			{
				id: 1, 
				note: "", 
				internalNote: "", 
				amount: 100, 
				amountAfterTax: 60, 
				clubUserPaymentSubscriptionPlanId: 1, 
				assignedUserId: 10, 
				userPaymentStatus: 1, 
				statusLastUpdated: null, 
				deadline: "2022-09-30 10:00", 
				PaidDateTime: null, 
				paymentReceiptId: 76, 
				approved: null, 
				approvedById: null, 
				lockExpire:  null, 
				lockedById: null, 
				isLocked: false, 
				lastReminderSent: null, 
				hasSentScheduledNotification: null, 
				paymentMethodInfoId: null, 
				paidWith: "PaymentMethodInfo"
			},
			{ 
				id: 2, 
				note: "", 
				internalNote: "", 
				amount: 100, 
				amountAfterTax: 60, 
				clubUserPaymentSubscriptionPlanId: 1, 
				assignedUserId: 10, 
				userPaymentStatus: 1, 
				statusLastUpdated: null, 
				deadline: "2022-09-30 10:00", 
				PaidDateTime: null, 
				paymentReceiptId: 76, 
				approved: null, 
				approvedById: null, 
				lockExpire:  null, 
				lockedById: null, 
				isLocked: false, 
				lastReminderSent: null, 
				hasSentScheduledNotification: null, 
				paymentMethodInfoId: null, 
				paidWith: "PaymentMethodInfo"
			},				
			{ 
				id: 3, 
				note: "", 
				internalNote: "", 
				amount: 100, 
				amountAfterTax: 60, 
				clubUserPaymentSubscriptionPlanId: 1, 
				assignedUserId: 10, 
				userPaymentStatus: 1, 
				statusLastUpdated: null, 
				deadline: "2022-09-30 10:00", 
				PaidDateTime: null, 
				paymentReceiptId: 76, 
				approved: null, 
				approvedById: null, 
				lockExpire:  null, 
				lockedById: null, 
				isLocked: false, 
				lastReminderSent: null, 
				hasSentScheduledNotification: null, 
				paymentMethodInfoId: null, 
				paidWith: "PaymentMethodInfo"
			},
			{ 
				id: 4, 
				note: "", 
				internalNote: "", 
				amount: 100, 
				amountAfterTax: 60, 
				clubUserPaymentSubscriptionPlanId: 1, 
				assignedUserId: 10, 
				userPaymentStatus: 1, 
				statusLastUpdated: null, 
				deadline: "2022-09-30 10:00", 
				PaidDateTime: null, 
				paymentReceiptId: 76, 
				approved: null, 
				approvedById: null, 
				lockExpire:  null, 
				lockedById: null, 
				isLocked: false, 
				lastReminderSent: null, 
				hasSentScheduledNotification: null, 
				paymentMethodInfoId: null, 
				paidWith: "PaymentMethodInfo"
			}				
		],
		durationInterval: "12",
	},
	{ 
		id: 2, 
		clubUserPaymentSubscriptionPlanstatus: 0, 
		assignedUserId: 10,
		amount: 100,
		paymentPeriodStartDate: "2022-08-30", 
		paymentPeriodEndDate: null, 
		cubPaymentSubscriptionId: 2,  
		clubUserPaymentSubscriptionCharges: [
			{ 
				id: 1, 
				note: "", 
				internalNote: "", 
				amount: 100, 
				amountAfterTax: 60, 
				clubUserPaymentSubscriptionPlanId: 2, 
				assignedUserId: 10, 
				userPaymentStatus: 1, 
				statusLastUpdated: null, 
				deadline: "2022-09-30 10:00", 
				PaidDateTime: null, 
				paymentReceiptId: 76, 
				approved: null, 
				approvedById: null, 
				lockExpire:  null, 
				lockedById: null, 
				isLocked: false, 
				lastReminderSent: null, 
				hasSentScheduledNotification: null, 
				paymentMethodInfoId: null, 
				paidWith: "PaymentMethodInfo"
			},
			{ 
				id: 2, 
				note: "", 
				internalNote: "", 
				amount: 100, 
				amountAfterTax: 60, 
				clubUserPaymentSubscriptionPlanId: 2, 
				assignedUserId: 10, 
				userPaymentStatus: 1, 
				statusLastUpdated: null, 
				deadline: "2022-09-30 10:00", 
				PaidDateTime: null, 
				paymentReceiptId: 76, 
				approved: null, 
				approvedById: null, 
				lockExpire:  null, 
				lockedById: null, 
				isLocked: false, 
				lastReminderSent: null, 
				hasSentScheduledNotification: null, 
				paymentMethodInfoId: null, 
				paidWith: "PaymentMethodInfo"
			},
			{ 
				id: 3, 
				note: "", 
				internalNote: "", 
				amount: 100, 
				amountAfterTax: 60, 
				clubUserPaymentSubscriptionPlanId: 2, 
				assignedUserId: 10, 
				userPaymentStatus: 1, 
				statusLastUpdated: null, 
				deadline: "2022-09-30 10:00", 
				PaidDateTime: null, 
				paymentReceiptId: 76, 
				approved: null, 
				approvedById: null, 
				lockExpire:  null, 
				lockedById: null, 
				isLocked: false, 
				lastReminderSent: null, 
				hasSentScheduledNotification: null, 
				paymentMethodInfoId: null, 
				paidWith: "PaymentMethodInfo"
			},
			{ 
				id: 4, 
				note: "", 
				internalNote: "", 
				amount: 100, 
				amountAfterTax: 60, 
				clubUserPaymentSubscriptionPlanId: 2, 
				assignedUserId: 10, 
				userPaymentStatus: 1, 
				statusLastUpdated: null, 
				deadline: "2022-09-30 10:00", 
				PaidDateTime: null, 
				paymentReceiptId: 76, 
				approved: null, 
				approvedById: null, 
				lockExpire:  null, 
				lockedById: null, 
				isLocked: false, 
				lastReminderSent: null, 
				hasSentScheduledNotification: null, 
				paymentMethodInfoId: null, 
				paidWith: "PaymentMethodInfo"
			}
		],
		durationInterval: "12",
	},
	{ 
		id: 3, 
		clubUserPaymentSubscriptionPlanstatus: 0, 
		assignedUserId: 10,
		amount: 100,
		paymentPeriodStartDate: "2022-08-30", 
		paymentPeriodEndDate: null, 
		cubPaymentSubscriptionId: 2,  
		clubUserPaymentSubscriptionCharges: [
			{ 
				id: 1, 
				note: "", 
				internalNote: "", 
				amount: 100, 
				amountAfterTax: 60, 
				clubUserPaymentSubscriptionPlanId: 3, 
				assignedUserId: 10, 
				userPaymentStatus: 1, 
				statusLastUpdated: null, 
				deadline: "2022-09-30 10:00", 
				PaidDateTime: null, 
				paymentReceiptId: 76, 
				approved: null, 
				approvedById: null, 
				lockExpire:  null, 
				lockedById: null, 
				isLocked: false, 
				lastReminderSent: null, 
				hasSentScheduledNotification: null, 
				paymentMethodInfoId: null, 
				paidWith: "PaymentMethodInfo"
			},
			{ 
				id: 2, 
				note: "", 
				internalNote: "", 
				amount: 100, 
				amountAfterTax: 60, 
				clubUserPaymentSubscriptionPlanId: 3, 
				assignedUserId: 10, 
				userPaymentStatus: 1, 
				statusLastUpdated: null, 
				deadline: "2022-09-30 10:00", 
				PaidDateTime: null, 
				paymentReceiptId: 76, 
				approved: null, 
				approvedById: null, 
				lockExpire:  null, 
				lockedById: null, 
				isLocked: false, 
				lastReminderSent: null, 
				hasSentScheduledNotification: null, 
				paymentMethodInfoId: null, 
				paidWith: "PaymentMethodInfo"
			},
			{ 
				id: 3, 
				note: "", 
				internalNote: "", 
				amount: 100, 
				amountAfterTax: 60, 
				clubUserPaymentSubscriptionPlanId: 3, 
				assignedUserId: 10, 
				userPaymentStatus: 1, 
				statusLastUpdated: null, 
				deadline: "2022-09-30 10:00", 
				PaidDateTime: null, 
				paymentReceiptId: 76, 
				approved: null, 
				approvedById: null, 
				lockExpire:  null, 
				lockedById: null, 
				isLocked: false, 
				lastReminderSent: null, 
				hasSentScheduledNotification: null, 
				paymentMethodInfoId: null, 
				paidWith: "PaymentMethodInfo"
			},
			{ 
				id: 4, 
				note: "", 
				internalNote: "", 
				amount: 100, 
				amountAfterTax: 60, 
				clubUserPaymentSubscriptionPlanId: 3, 
				assignedUserId: 10, 
				userPaymentStatus: 1, 
				statusLastUpdated: null, 
				deadline: "2022-09-30 10:00", 
				PaidDateTime: null, 
				paymentReceiptId: 76, 
				approved: null, 
				approvedById: null, 
				lockExpire:  null, 
				lockedById: null, 
				isLocked: false, 
				lastReminderSent: null, 
				hasSentScheduledNotification: null, 
				paymentMethodInfoId: null, 
				paidWith: "PaymentMethodInfo"
			}
		],
		durationInterval: "12",
	},
	{ 	
		id: 4, 
		clubUserPaymentSubscriptionPlanstatus: 0, 
		assignedUserId: 10,
		amount: 100,
		paymentPeriodStartDate: "2022-08-30", 
		paymentPeriodEndDate: null, 
		cubPaymentSubscriptionId: 2,  
		clubUserPaymentSubscriptionCharges: [
			{ 
				id: 1, 
				note: "", 
				internalNote: "", 
				amount: 100, 
				amountAfterTax: 60, 
				clubUserPaymentSubscriptionPlanId: 4, 
				assignedUserId: 10, 
				userPaymentStatus: 1, 
				statusLastUpdated: null, 
				deadline: "2022-09-30 10:00", 
				PaidDateTime: null, 
				paymentReceiptId: 76, 
				approved: null, 
				approvedById: null, 
				lockExpire:  null, 
				lockedById: null, 
				isLocked: false, 
				lastReminderSent: null, 
				hasSentScheduledNotification: null, 
				paymentMethodInfoId: null, 
				paidWith: "PaymentMethodInfo"
			},			
			{ 
				id: 2, 
				note: "", 
				internalNote: "", 
				amount: 100, 
				amountAfterTax: 60, 
				clubUserPaymentSubscriptionPlanId: 4, 
				assignedUserId: 10, 
				userPaymentStatus: 1, 
				statusLastUpdated: null, 
				deadline: "2022-09-30 10:00", 
				PaidDateTime: null, 
				paymentReceiptId: 76, 
				approved: null, 
				approvedById: null, 
				lockExpire:  null, 
				lockedById: null, 
				isLocked: false, 
				lastReminderSent: null, 
				hasSentScheduledNotification: null, 
				paymentMethodInfoId: null, 
				paidWith: "PaymentMethodInfo"
			},				
			{ 
				id: 3, 
				note: "", 
				internalNote: "", 
				amount: 100, 
				amountAfterTax: 60, 
				clubUserPaymentSubscriptionPlanId: 4, 
				assignedUserId: 10, 
				userPaymentStatus: 1, 
				statusLastUpdated: null, 
				deadline: "2022-09-30 10:00", 
				PaidDateTime: null, 
				paymentReceiptId: 76, 
				approved: null, 
				approvedById: null, 
				lockExpire:  null, 
				lockedById: null, 
				isLocked: false, 
				lastReminderSent: null, 
				hasSentScheduledNotification: null, 
				paymentMethodInfoId: null, 
				paidWith: "PaymentMethodInfo"
			},			
			{ 
				id: 4, 
				note: "", 
				internalNote: "", 
				amount: 100, 
				amountAfterTax: 60, 
				clubUserPaymentSubscriptionPlanId: 4, 
				assignedUserId: 10, 
				userPaymentStatus: 1, 
				statusLastUpdated: null, 
				deadline: "2022-09-30 10:00", 
				PaidDateTime: null, 
				paymentReceiptId: 76, 
				approved: null, 
				approvedById: null, 
				lockExpire:  null, 
				lockedById: null, 
				isLocked: false, 
				lastReminderSent: null, 
				hasSentScheduledNotification: null, 
				paymentMethodInfoId: null, 
				paidWith: "PaymentMethodInfo"
			}
		],
		durationInterval: "12",
	}
]

export const subscriptionCharges = [
	{
		id: 1, 
		note: "", 
		internalNote: "", 
		amount: 100, 
		amountAfterTax: 60, 
		clubUserPaymentSubscriptionPlanId: 1, 
		assignedUserId: 10, 
		userPaymentStatus: 2, 
		statusLastUpdated: null, 
		deadline: "2022-09-30 10:00", 
		PaidDateTime: null, 
		paymentReceiptId: 76, 
		approved: null, 
		approvedById: null, 
		lockExpire:  null, 
		lockedById: null, 
		isLocked: false, 
		lastReminderSent: null, 
		hasSentScheduledNotification: null, 
		paymentMethodInfoId: null, 
		paidWith: "PaymentMethodInfo"
	},
	{ 
		id: 2, 
		note: "", 
		internalNote: "", 
		amount: 100, 
		amountAfterTax: 60, 
		clubUserPaymentSubscriptionPlanId: 1, 
		assignedUserId: 10, 
		userPaymentStatus: 1, 
		statusLastUpdated: null, 
		deadline: "2022-09-30 10:00", 
		PaidDateTime: null, 
		paymentReceiptId: 76, 
		approved: null, 
		approvedById: null, 
		lockExpire:  null, 
		lockedById: null, 
		isLocked: false, 
		lastReminderSent: null, 
		hasSentScheduledNotification: null, 
		paymentMethodInfoId: null, 
		paidWith: "PaymentMethodInfo"
	},				
	{ 
		id: 3, 
		note: "", 
		internalNote: "", 
		amount: 100, 
		amountAfterTax: 60, 
		clubUserPaymentSubscriptionPlanId: 1, 
		assignedUserId: 10, 
		userPaymentStatus: 1, 
		statusLastUpdated: null, 
		deadline: "2022-09-30 10:00", 
		PaidDateTime: null, 
		paymentReceiptId: 76, 
		approved: null, 
		approvedById: null, 
		lockExpire:  null, 
		lockedById: null, 
		isLocked: false, 
		lastReminderSent: null, 
		hasSentScheduledNotification: null, 
		paymentMethodInfoId: null, 
		paidWith: "PaymentMethodInfo"
	},
	{ 
		id: 4, 
		note: "", 
		internalNote: "", 
		amount: 100, 
		amountAfterTax: 60, 
		clubUserPaymentSubscriptionPlanId: 1, 
		assignedUserId: 10, 
		userPaymentStatus: 1, 
		statusLastUpdated: null, 
		deadline: "2022-09-30 10:00", 
		PaidDateTime: null, 
		paymentReceiptId: 76, 
		approved: null, 
		approvedById: null, 
		lockExpire:  null, 
		lockedById: null, 
		isLocked: false, 
		lastReminderSent: null, 
		hasSentScheduledNotification: null, 
		paymentMethodInfoId: null, 
		paidWith: "PaymentMethodInfo"
	}	
]
